import { gql } from "@apollo/client";

export const GET_CONSULTAS = gql`
    query GetConsultas {
        consultas {
        valorEsperado{
                idConsulta
                dataPrivacy
                storedProcedure
                mostrarGrilla
                nombre
                descripcion
            }
        }
    }
`;

export const adaptConsultasGeneralesArray = (data) => {
    return data?.map((consulta) => ({
        id: consulta.idConsulta,
        dataPrivacy: consulta.dataPrivacy,
        storedProcedure: consulta.storedProcedure,
        mostrarGrilla: consulta.mostrarGrilla,
        displayName: consulta.nombre,
        descripcion: consulta.descripcion
    }));
};
